import React from "react";
import { Image } from "@sparefoot/react-commons";
import { H2, Paragraph, Text, Link } from "components/core/Typography";
import { COMPANY_COUNT } from "../PaidLandingData";
import "./StorageCompanyCount.scss";

function StorageCompanyCount() {
	return (
		<>
			<div className="storage-company-count">
				<H2
					color="darkBlue"
					className="heading"
				>
					{COMPANY_COUNT.heading}
				</H2>
				<Paragraph
					size="medium"
					color="gray"
				>
					{COMPANY_COUNT.description}
				</Paragraph>
				<div className="images-container">
					{COMPANY_COUNT.images.map((image) => (
						<Image
							src={image}
							alt="image"
						/>
					))}
				</div>
			</div>
			<Text className="last-text">
				© 2023 Storage.com All rights reserved.{" "}
				<Link
					href="/about-us/terms-and-conditions/"
					color="black"
				>
					Terms of Service
				</Link>{" "}
				and{" "}
				<Link
					href="/about-us/privacy/"
					color="black"
				>
					Privacy Policy
				</Link>
				.
			</Text>
		</>
	);
}

export default StorageCompanyCount;
